/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Specific_Fields_For_This_CaInputs */

const en_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific fields for this category`)
};

const es_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay campos específicos para esta categoría`)
};

const fr_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun champ spécifique pour cette catégorie`)
};

const de_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine spezifischen Felder für diese Kategorie`)
};

const ja_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このカテゴリに特有のフィールドはありません`)
};

const zh_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此类别没有特定的专用字段`)
};

const ar_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد حقول محددة لهذه الفئة`)
};

const id_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kolom spesifik untuk kategori ini`)
};

const it_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun campo specifico per questa categoria`)
};

const ru_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этой категории нет специальных полей`)
};

const pt_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum campo específico para esta categoria`)
};

const ko_no_specific_fields_for_this_ca = /** @type {(inputs: No_Specific_Fields_For_This_CaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 카테고리에 특정된 필드가 없습니다`)
};

/**
* | output |
* | --- |
* | "No specific fields for this category" |
*
* @param {No_Specific_Fields_For_This_CaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_specific_fields_for_this_ca = /** @type {((inputs?: No_Specific_Fields_For_This_CaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Specific_Fields_For_This_CaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_specific_fields_for_this_ca(inputs)
	if (locale === "es") return es_no_specific_fields_for_this_ca(inputs)
	if (locale === "fr") return fr_no_specific_fields_for_this_ca(inputs)
	if (locale === "de") return de_no_specific_fields_for_this_ca(inputs)
	if (locale === "ja") return ja_no_specific_fields_for_this_ca(inputs)
	if (locale === "zh") return zh_no_specific_fields_for_this_ca(inputs)
	if (locale === "ar") return ar_no_specific_fields_for_this_ca(inputs)
	if (locale === "id") return id_no_specific_fields_for_this_ca(inputs)
	if (locale === "it") return it_no_specific_fields_for_this_ca(inputs)
	if (locale === "ru") return ru_no_specific_fields_for_this_ca(inputs)
	if (locale === "pt") return pt_no_specific_fields_for_this_ca(inputs)
	return ko_no_specific_fields_for_this_ca(inputs)
});